import React, { useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

import { createMemberType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

const MEMBER_CLASS_OPTIONS = [
  "Collaborator",
  "CompanyMember",
  "Specialist",
  "Investor",
  "ProductUser",
];

export default function MemberTypeCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    memberTypeName: "",
    memberTypeDescription: "",
    memberClass: "",
    values: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createMemberType(businessDomainId, {
        ...form,
        companyId: COMPANY_ID,
        businessDomainId,
      });
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/member-types`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("memberType.create.title")}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              label={t("memberType.name")}
              name="memberTypeName"
              value={form.memberTypeName}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={t("memberType.description")}
              name="memberTypeDescription"
              value={form.memberTypeDescription}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("memberType.memberClass")}</InputLabel>
              <Select
                name="memberClass"
                value={form.memberClass}
                label={t("memberType.memberClass")}
                onChange={handleChange}
              >
                {MEMBER_CLASS_OPTIONS.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {t(`memberType.class.${opt}`)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <TextField
              fullWidth
              required
              multiline
              rows={3}
              label={t("memberType.values")}
              name="values"
              value={form.values}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">
            {t("common.add")}
          </Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/member-types`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
